/** The queue entry of the board menu: a router link with the To do count as a badge. */
import { Link } from 'react-router-dom';
import { Badge, Icon } from '@insio/ui-toolkit';
import { useFeatureTranslation } from '@/hooks/useFeatureTranslation';

/** Counts above this show as "99+" so the badge keeps its width. */
export const QUEUE_BADGE_MAX = 99;

interface QueueMenuLinkProps {
  href: string;
  label: string;
  count: number;
  isActive: boolean;
  className: string;
}

export function QueueMenuLink({ href, label, count, isActive, className }: QueueMenuLinkProps) {
  const t = useFeatureTranslation('masterAccountBoardShell.menu');
  const tone = isActive ? 'text-secondary-base' : 'text-foreground-base';

  return (
    <Link to={href} className={className} data-testid='master-account-queue-menu-link'>
      <Icon name='list-ul' className={tone} />
      <span className={`font-medium ${tone}`}>{label}</span>
      {count > 0 && (
        <>
          <span aria-hidden='true' data-testid='master-account-queue-menu-badge'>
            <Badge size='sm' color='error'>
              {count > QUEUE_BADGE_MAX ? t('queueBadgeOverflow') : count}
            </Badge>
          </span>
          <span className='sr-only'>{t('queueToDo', { count })}</span>
        </>
      )}
    </Link>
  );
}
